<div class="modal-header py-2 bg-dark text-light">
    <h4 class="modal-title">
        차량정보
    </h4>
</div>

<div class="modal-body">
    <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
        <div class="row">
            <div class="col">
                <div class="form-group row align-items-center">
                    <label class="col-md-4 mb-0">
                        차량번호
                    </label>
                    <div class="col-md-8 position-relative">
                        <input type="text" class="form-control-sm form-control-plaintext"
                            formControlName="dtgCarNo"
                            readonly>
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <label class="col-md-4 mb-0">
                        차대번호
                    </label>
                    <div class="col-md-8 position-relative">
                        <div class="input-group input-group-sm">
                            <input type="text" class="form-control-sm form-control-plaintext"
                                formControlName="dtgVin"
                                readonly>
                            <div class="input-group-append">
                                <span class="input-group-text">
                                    {{cntVin()}}/17
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <label class="col-md-4 mb-0">
                        차량종류
                    </label>
                    <div class="col-md-8 position-relative">
                        <input type="text" class="form-control-sm form-control-plaintext"
                            formControlName="dtgCarTypeNm"
                            readonly>
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <label class="col-md-4 mb-0">
                        사업자등록번호
                    </label>
                    <div class="col-md-8 position-relative">
                        <div class="input-group input-group-sm">
                            <input type="text" class="form-control-sm form-control-plaintext"
                                formControlName="dtgEid"
                                readonly>
                            <div class="input-group-append">
                                <span class="input-group-text">
                                    {{cntEid()}}/10
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <label class="col-md-4 mb-0">
                        소속회사
                    </label>
                    <div class="col-md-8 position-relative">
                        <div class="input-group input-group-sm">
                            <input type="text" class="form-control form-control-sm"
                                formControlName="companyNm"
                                readonly>
                            <div class="input-group-append">
                                <button type="button" class="btn btn-sm btn-outline-secondary"
                                    (click)="clickOpenModalCompanyInfo(DtgActionType.read)">
                                    회사변경
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <label class="col-md-4 mb-0">
                        그룹이름
                    </label>
                    <div class="col-md-8 position-relative">
                        <select class="form-control form-control-sm w-auto"
                            formControlName="dtgTeamId">
                            <option [ngValue]="null">미설정</option>
                            <option *ngFor="let item of listTeam;"
                                [ngValue]="item.dtgTeamId">
                                {{item.dtgTeamNm}}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <label class="col-md-4 mb-0">
                        메모
                    </label>
                    <div class="col-md-8 position-relative">
                        <input type="text" class="form-control form-control-sm"
                            formControlName="memo"
                            ngbAutofocus>
                    </div>
                </div>

                <div class="form-group row align-items-center mb-0">
                    <label class="col-md-4 mb-0">
                        사용여부
                    </label>
                    <div class="col-md-8 position-relative">
                        <select class="form-control form-control-sm w-auto"
                            formControlName="useYn">
                            <option [ngValue]="'Y'">사용</option>
                            <option [ngValue]="'N'">미사용</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="form-group row align-items-center">
                    <label class="col-md-4 mb-0">
                        단말번호
                    </label>
                    <div class="col-md-8 position-relative">
                        <input type="text" class="form-control-sm form-control-plaintext"
                            formControlName="dtgUnitId"
                            readonly>
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <label class="col-md-4 mb-0">
                        형식승인번호
                    </label>
                    <div class="col-md-8 position-relative">
                        <input type="text" class="form-control-sm form-control-plaintext"
                            formControlName="dtgKcNo"
                            readonly>
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <label class="col-md-4 mb-0">
                        일련번호
                    </label>
                    <div class="col-md-8 position-relative">
                        <input type="text" class="form-control-sm form-control-plaintext"
                            formControlName="dtgDeviceSn"
                            readonly>
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <label class="col-md-4 mb-0">
                        모델번호
                    </label>
                    <div class="col-md-8 position-relative">
                        <input type="text" class="form-control-sm form-control-plaintext"
                            formControlName="dtgModelNo"
                            readonly>
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <label class="col-md-4 mb-0">
                        펌웨어정보
                    </label>
                    <div class="col-md-8 position-relative">
                        <input type="text" class="form-control-sm form-control-plaintext"
                            formControlName="dtgFirmwareInfo"
                            readonly>
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <label class="col-md-4 mb-0">
                        서비스 시작
                    </label>
                    <div class="col-md-8 position-relative">
                        <input type="text" class="form-control-sm form-control-plaintext"
                            formControlName="serviceDtFrom"
                            readonly>
                    </div>
                </div>

                <div class="form-group row align-items-center">
                    <label class="col-md-4 mb-0">
                        마지막 수신
                    </label>
                    <div class="col-md-8 position-relative">
                        <input type="text" class="form-control-sm form-control-plaintext"
                            formControlName="updateDt"
                            readonly>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-success btn-sm"
        (click)="clickSave()"
        [hidden]="dtgActionType === DtgActionType.read">
        <i class="mdi mdi-content-save"></i>
        <span class="ml-1">
            저장
        </span>
    </button>
    <button type="button" class="btn btn-secondary btn-sm"
        (click)="clickCancel()">
        <i class="mdi mdi-close"></i>
        <span class="ml-1">
            취소
        </span>
    </button>
</div>
